import angular from "angular";
import { vsModuleName as sharedContractModuleName } from "../../../Contract/shared";
import {
  vsProviderName as contractServiceProviderName,
  ContractServiceProvider,
} from "../../../Contract/shared/ContractService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as serverUtilityName,
} from "../../../records/server/serverUtility";
import { ServiceResponse } from "../../../records/server/query";
import { GridConfiguration } from "../../../records/views/recordGridView";
import { MasterAgreementGridConfigurationFactory } from "../../../Contract/views/types/masterAgreement/gridConfiguration";
import { GamingMasterAgreementGridConfigurationFactory } from "../../../Contract/views/types/gamingMasterAgreement/gridConfiguration";
import { GamingContractGridConfigurationFactory } from "../../../Contract/views/types/gamingContract/gridConfiguration";
import { ContractGridConfigurationFactory } from "../../../Contract/views/types/contract/gridConfiguration";
import { Record } from "../../../records/server/crud";
import { vsComponentName as relationshipEditComponentName } from "../../../Contract/views/relationship/edit";
import { vsComponentName as gamingRelationshipEditComponentName } from "../../../Contract/views/gamingRelationship/edit";

export const vsModuleName = "Contracts.DesertDiamond";

const childTabViewAddress = "tabs@";

angular.module(
  vsModuleName,
  [sharedContractModuleName],
  [
    contractServiceProviderName,
    (contractServiceProvider: ContractServiceProvider) => {
      contractServiceProvider.addContractTab({
        name: "Relationships",
        state: {
          url: "/relationships",
          views: { tabs: { component: "relationshipGridComponent" } },
        },
        uiSref: "relationships",
        children: [
          {
            name: "Edit",
            state: {
              url: "edit",
              views: {
                "tabs@main.contract.type.info": {
                  component: relationshipEditComponentName
                }
              }
            },
            uiSref: "edit",            
          }
        ],
      });

      contractServiceProvider.addContractTab({
        name: "Gaming Relationships",
        state: {
          url: "/gamingRelationships",
          views: { tabs: { component: "gamingRelationshipGridComponent" } },
        },
        uiSref: "gamingRelationships",
        children: [
          {
            name: "Edit",
            state: {
              url: "edit",
              views: {
                "tabs@main.contract.type.info": {
                  component: gamingRelationshipEditComponentName
                }
              }
            },
            uiSref: "edit",            
          }
        ],
      });

      contractServiceProvider.addContractType({
        id: "contractMasterAgreement",
        name: "Master Agreement",
        formComponentName: "contractMasterAgreementEditComponent",
        detailComponentName: "contractMasterDetailComponent",
        gridConfiguration: MasterAgreementGridConfigurationFactory,
        tabs: [],
      });

     

      contractServiceProvider.addContractType({
        id: "contract",
        name: "Contract",
        formComponentName: "contractEditComponent",
        detailComponentName: "contractDetailComponent",
        gridConfiguration: ContractGridConfigurationFactory,
        tabs: [
          {
            name: "Machines",
            uiSref: "machines",
            state: {
              url: "/machines",
              views: {
                tabs: {
                  component: "machineDetailMachinesView",
                },
              },
            },
            children: [
              {
                name: "Edit",
                uiSref: "edit",
                state: {
                  url: "/edit",
                  views: {
                    "tabs@main.contract.type.info": {
                      component: "machineDetailMachinesEdit",
                    },
                  },
                  resolve: {
                    contractMachineIds: [
                      serverUtilityName,
                      "contract",
                      function (
                        serverUtility: ServerUtility,
                        contract: Record
                      ) {
                        return serverUtility
                          .fetchAll<Record>({
                            url: `api/contract/contractMachines/${contract.Id}`,
                            query: {
                              Fields: "MachineId",
                            },
                          })
                          .then((result) => result.map((r) => r.MachineId));
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      });
      contractServiceProvider.addContractType({
        id: "gamingContractMasterAgreement",
        name: "Gaming Master Agreement",
        formComponentName: "gamingContractMasterAgreementEditComponent",
        detailComponentName: "gamingContractMasterDetailComponent",
        gridConfiguration: GamingMasterAgreementGridConfigurationFactory,
        tabs: [],
      });

      contractServiceProvider.addContractType({
        id: "gamingContract",
        name: "Gaming Contract",
        formComponentName: "gamingContractEditComponent",
        detailComponentName: "gamingContractDetailComponent",
        gridConfiguration: GamingContractGridConfigurationFactory,
        tabs: [],
      });
    },
  ]
);
